import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {errorMessage} from "../../utils/messages";
import SuppliersService from "services/SuppliersService";
import DbUtils from "../../utils/indexDB";
import {CURRENT_COMPANY_SUPPLIERS} from "../../constants/AuthConstant";

export const initialState = {
    loadingSuppliers: false,
    loadedSuppliers: false,
    suppliers: [],
    errorSuppliers: false,
}

const DB_NAME = 'MySuppliersDB';
const STORE_NAME = 'suppliers';
const VERSION = 1;
// Define constants for IndexedDB and caching
const LAST_SYNC_TIMESTAMP = 'SUPPLIERS_LAST_FULL_SYNC';

function mergeSuppliers(cachedSuppliers, updatedSuppliers) {
    const supplierMap = new Map(cachedSuppliers.map(p => [p.documentId, p]));

    for (let updated of updatedSuppliers) {
        supplierMap.set(updated.documentId, updated);
    }

    return Array.from(supplierMap.values());
}

export const loadSuppliers = createAsyncThunk('carica-suppliers', async (data, {rejectWithValue}) => {
    console.log("[loadSuppliers]");
    try {
        console.log("data in loadSuppliers", data);
        const currentCompanyId = data.documentId;

        const lastCompanyId = localStorage.getItem(CURRENT_COMPANY_SUPPLIERS);
        const cachedSuppliers = await DbUtils.getAll(DB_NAME, VERSION, STORE_NAME);

        const lastFullSync = localStorage.getItem(LAST_SYNC_TIMESTAMP);
        const now = new Date().getTime();
        const oneDayInMs = 24 * 60 * 60 * 1000;
        const shouldForceFullSync = !lastFullSync || (now - parseInt(lastFullSync)) > oneDayInMs;

        console.log("currentCompanyId !== lastCompanyId || !cachedSuppliers || cachedSuppliers.length === 0 || shouldForceFullSync", currentCompanyId !== lastCompanyId, !cachedSuppliers, cachedSuppliers.length === 0, shouldForceFullSync)
        if (currentCompanyId !== lastCompanyId || !cachedSuppliers || cachedSuppliers.length === 0 || shouldForceFullSync) {
            console.log('Nuova azienda o nessuna cache trovata o sync giornaliero, fetch completo dal server...');

            const response = await SuppliersService.getSources(currentCompanyId);
            console.log("suppliers: ", response);


            const suppliers = response.data.filter((item)=>item.supplier!==null).map((item) => ({
                id: item.supplier?.id,
                documentId: item.supplier?.documentId,
                updatedAt: item.supplier?.updatedAt,
                ...item.supplier,
            }));

            localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

            await DbUtils.clearAllAndSaveItem(suppliers, DB_NAME, VERSION, STORE_NAME);
            console.log("suppliers: ", suppliers)

            return {suppliers, company: currentCompanyId};
        } else {
            console.log('Stessa azienda, verifico aggiornamenti dalla cache...');

            const countResponse = await SuppliersService.getSourcesCount(currentCompanyId);
            console.log("countResponse: ", countResponse)
            const serverSuppliersCount = countResponse.meta.pagination.total;

            if (serverSuppliersCount < cachedSuppliers.length) {
                console.log('Rilevate cancellazioni nel database remoto, eseguo sync completo...');

                const response = await SuppliersService.getSources(currentCompanyId);
                console.log("suppliers: ", response);

                const suppliers = response.data.map((item) => ({
                    id: item.supplier.id,
                    documentId: item.supplier.documentId,
                    updatedAt: item.supplier.updatedAt,
                    ...item.supplier,
                }));

                localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

                await DbUtils.clearAllAndSaveItem(suppliers, DB_NAME, VERSION, STORE_NAME);
                console.log("fornitori aggiornati dopo rilevamento cancellazioni: ", suppliers);

                return {suppliers, company: currentCompanyId};
            }

            const latestUpdatedAt = cachedSuppliers.reduce((latest, supplier) => {
                const updatedDate = new Date(supplier.updatedAt);
                return updatedDate > latest ? updatedDate : latest;
            }, new Date(0));

            console.log("Ultimo aggiornamento cache:", latestUpdatedAt.toISOString());

            const response = await SuppliersService.getSourcesAfter(currentCompanyId, latestUpdatedAt.toISOString());

            const updatedSuppliers = response.data.map((item) => ({
                id: item.supplier.id,
                documentId: item.supplier.documentId,
                updatedAt: item.supplier.updatedAt,
                ...item.supplier,
            }));

            if (updatedSuppliers.length > 0) {
                console.log('Ci sono aggiornamenti dal server, aggiorno cache...');
                console.log('Ci sono aggiornamenti dal server, aggiorno cache cachedSuppliers...',cachedSuppliers);
                console.log('Ci sono aggiornamenti dal server, aggiorno cache updatedSuppliers...',updatedSuppliers);
                const mergedSuppliers = mergeSuppliers(cachedSuppliers, updatedSuppliers);
                await DbUtils.saveItem(mergedSuppliers, DB_NAME, VERSION, STORE_NAME);
                console.log("mergedSuppliers: ", mergedSuppliers)
                return {suppliers: mergedSuppliers, company: currentCompanyId};
            } else {
                console.log('Nessun aggiornamento, uso la cache.');
                return {suppliers: cachedSuppliers, company: currentCompanyId};
            }
        }

    } catch (err) {
        console.log("ale-debug2",err)
        console.error("err", err)
        let message = (
            <div>
                Qualcosa è andato storto nel recuperare i Fornitori. Riprovare!
                <br/>
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
});

export const newSupplier = createAsyncThunk('aggiungi-supplier', async (body, {rejectWithValue, getState}) => {
    try {
        console.log("body request nuovo supplier", body)
        await SuppliersService.addSupplier(body);

    } catch (err) {
        console.error("err", err)
        let message = (
            <div>
                Non è stato possibile aggiungere il fornitore.
                <br/>
                Se il problema persiste, contattare l' assistenza.
            </div>
        );
        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
});

const cleanSupplierData = ({id, documentId, createdAt, updatedAt, publishedAt, ...restData}) => {
    return restData;
};

export const updateSupplier = createAsyncThunk('aggiorna-supplier', async (body, {rejectWithValue, getState}) => {
    try {
        console.log("body request aggiornamento supplier", body);

        const response = await SuppliersService.updateSupplier(body.documentId, {data:body.data});
        return response.data;
    } catch (err) {
        console.error("err", err);
        let message = (
            <div>
                Non è stato possibile aggiornare il fornitore.
                <br/>
                Se il problema persiste, contattare l'assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE');
    }
});

export const deleteSupplier = createAsyncThunk('elimina-supplier', async (supplierId, {rejectWithValue, getState}) => {
    try {
        console.log("Eliminazione supplier con ID:", supplierId);
        // Assumo che tu abbia un metodo nel service per la cancellazione
        const response = await SuppliersService.deleteSource(supplierId);
        return response.data;
    } catch (err) {
        console.error("err", err);
        let message = (
            <div>
                Non è stato possibile eliminare il fornitore.
                <br/>
                Se il problema persiste, contattare l'assistenza.
            </div>
        );

        //errorMessage(message)
        return rejectWithValue('ERRORE');
    }
});

export const suppliers = createSlice({
    name: 'suppliers',
    initialState,
    reducers: {
        resetState: (state, action) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadSuppliers.pending, (state) => {
                state.loadingSuppliers = true
                state.loadedSuppliers = false
                state.errorSuppliers = false
            })
            .addCase(loadSuppliers.fulfilled, (state, action) => {
                console.log("eccomi e loading è", state.loadingSuppliers)
                console.log("action.payload", action.payload)
                state.loadingSuppliers = false
                state.loadedSuppliers = true
                // Ensure suppliers is always an array
                state.suppliers = action.payload.suppliers || []
                state.errorSuppliers = false
                state.currentCompany = action.payload.company
                localStorage.setItem(CURRENT_COMPANY_SUPPLIERS, action.payload.company)

            })
            .addCase(loadSuppliers.rejected, (state, action) => {
                state.loadingSuppliers = false
                state.loadedSuppliers = true
                state.suppliers = []
                state.errorSuppliers = true
            })

    }
})

export default suppliers.reducer;